import React from "react";

export default () => (
  <>
    <h1>Calculadora</h1>
    <ul>
      <li>Todas acumulan lo mismo</li>
      <li>1% en Restaurantes y Comidas Rápidas</li>
      <li>1% en farmacias</li>
      <li>
        1% en Gasolineras, Tiendas por departamentos, Ropa y Zapatería,
        Supermercados
      </li>
      <li>
        5% de CashBack con sus compras en BM Supermercados, la principal cadena
        de supermercados en la Zona Sur. Además puede redimir en cualquier BM
        Supermercado los CashBack acumulados.
      </li>
    </ul>
  </>
);
